import _ from "lodash";

const TOLERANCE_PLOTLINE_ID = "tolerancePlotLine";

const baseOffsetPlotLine = {
  width: 1,
  dashStyle: "shortDot",
  color: "purple",
  zIndex: 5,
  id: TOLERANCE_PLOTLINE_ID
};

export const SideOffsetMinPlotline = _.merge({}, baseOffsetPlotLine, {
  value: -0.5
});

export const SideOffsetMaxPlotline = _.merge({}, baseOffsetPlotLine, {
  value: 0.5
});

export const HeightOffsetMinPlotline = _.merge({}, baseOffsetPlotLine, {
  value: -0.8
});

export const HeightOffsetMaxPlotline = _.merge({}, baseOffsetPlotLine, {
  value: 0.8
});

export const toleranceLegendItem = (xAxis, yAxis) => {
  const clonedXAxis = _.cloneDeep(xAxis);
  const clonedYAxis = _.cloneDeep(yAxis);

  const filterTolerancePlotines = plotLine =>
    plotLine.id === TOLERANCE_PLOTLINE_ID;

  const xAxisPlotlines = _.filter(
    clonedXAxis.plotLines,
    filterTolerancePlotines
  );
  const yAxisPlotlines = _.filter(
    clonedYAxis.plotLines,
    filterTolerancePlotines
  );

  if (_.isEmpty(xAxisPlotlines) && _.isEmpty(yAxisPlotlines)) {
    return undefined;
  }

  return {
    color: "purple",
    name: "Tolerance Boundary",
    dashStyle: "shortDot",
    marker: {
      enabled: false
    },
    events: {
      legendItemClick: function(e) {
        if (this.visible) {
          this.chart.xAxis[0].removePlotLine(TOLERANCE_PLOTLINE_ID);
          this.chart.yAxis[0].removePlotLine(TOLERANCE_PLOTLINE_ID);
        } else {
          xAxisPlotlines.forEach(plotLine => {
            this.chart.xAxis[0].addPlotLine(plotLine);
          });
          yAxisPlotlines.forEach(plotLine => {
            this.chart.yAxis[0].addPlotLine(plotLine);
          });
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/utils/groundTruthPlotLines.js